import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ArrowRight, CheckCircle, Copy, Check, MessageSquare, Smartphone, Share2, Heart, Clock, FileText, Forward, Zap, UserPlus, History, Send, Play } from 'lucide-react';
import { Link } from 'react-router-dom';
export function RelationshipLandingPage() {
  const [copied, setCopied] = useState(false);
  const phoneNumber = '(774) 472-7423';
  const smsHref = `sms:+1${phoneNumber.replace(/\D/g, '')}?body=Hi%20ScribeTok!%20I%20want%20to%20transcribe%20a%20video.`;
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen w-full bg-background px-4 py-12 md:px-16 lg:px-32 flex flex-col items-center justify-center overflow-x-hidden" data-id="element-851">
      <div className="w-full max-w-4xl mx-auto text-center" data-id="element-852">
        {/* Logo */}
        <div className="flex justify-center mb-6" data-id="element-853">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tsscMEhsZ3L4JwT2r374e/ScribeTok-logo.png" alt="ScribeTok Logo" className="h-14 w-auto" data-id="element-854" />
        </div>
        {/* Hero Section */}
        <div className="mb-2" data-id="element-855">
          <span className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-856">
            Watch → Read → Connect
          </span>
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-slide-down" style={{
        animationDelay: '100ms'
      }} data-id="element-857">
          Sick of Your Partner{' '}
          <span className="text-primary" data-id="element-858">Ignoring Your TikToks?</span>
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8 animate-slide-down" style={{
        animationDelay: '200ms'
      }} data-id="element-859">
          With ScribeTok, you can send them a transcript so they'll actually get
          the point—no headphones, no app, no wait.
        </p>
        <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-860">
          Paste any TikTok, YouTube, Instagram or Facebook link and instantly
          see how viewers connect with the content
        </p>
        {/* Problem/Solution Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 animate-scale" style={{
        animationDelay: '300ms'
      }} data-id="element-861">
          {/* Problem Card */}
          <Card className="text-left" data-id="element-862">
            <CardContent className="p-6" data-id="element-863">
              <h3 className="text-xl font-medium mb-4 flex items-center" data-id="element-864">
                <Clock size={20} className="text-primary mr-2" data-id="element-865" />
                The Problem
              </h3>
              <ul className="space-y-3" data-id="element-866">
                <li className="flex items-start gap-3" data-id="element-867">
                  <div className="w-6 h-6 rounded-full bg-destructive/20 flex items-center justify-center text-destructive flex-shrink-0 mt-0.5" data-id="element-868">
                    ✗
                  </div>
                  <p className="text-muted-foreground" data-id="element-869">
                    <span className="font-medium text-foreground" data-id="element-870">
                      TikToks get lost in chat
                    </span>{' '}
                    — never actually watched
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-871">
                  <div className="w-6 h-6 rounded-full bg-destructive/20 flex items-center justify-center text-destructive flex-shrink-0 mt-0.5" data-id="element-872">
                    ✗
                  </div>
                  <p className="text-muted-foreground" data-id="element-873">
                    <span className="font-medium text-foreground" data-id="element-874">
                      "I'll watch it later"
                    </span>{' '}
                    — but they never do
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-875">
                  <div className="w-6 h-6 rounded-full bg-destructive/20 flex items-center justify-center text-destructive flex-shrink-0 mt-0.5" data-id="element-876">
                    ✗
                  </div>
                  <p className="text-muted-foreground" data-id="element-877">
                    <span className="font-medium text-foreground" data-id="element-878">
                      Micro-friction in relationships
                    </span>{' '}
                    — "Did you see that thing I sent?"
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-879">
                  <div className="w-6 h-6 rounded-full bg-destructive/20 flex items-center justify-center text-destructive flex-shrink-0 mt-0.5" data-id="element-880">
                    ✗
                  </div>
                  <p className="text-muted-foreground" data-id="element-881">
                    <span className="font-medium text-foreground" data-id="element-882">
                      Wrong moment to watch
                    </span>{' '}
                    — in meetings, public places, or busy
                  </p>
                </li>
              </ul>
            </CardContent>
          </Card>
          {/* Solution Card */}
          <Card className="text-left" data-id="element-883">
            <CardContent className="p-6" data-id="element-884">
              <h3 className="text-xl font-medium mb-4 flex items-center" data-id="element-885">
                <Zap size={20} className="text-primary mr-2" data-id="element-886" />
                The Solution
              </h3>
              <ul className="space-y-3" data-id="element-887">
                <li className="flex items-start gap-3" data-id="element-888">
                  <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center text-success flex-shrink-0 mt-0.5" data-id="element-889">
                    ✓
                  </div>
                  <p className="text-muted-foreground" data-id="element-890">
                    <span className="font-medium text-foreground" data-id="element-891">
                      Convert TikToks to text
                    </span>{' '}
                    — instantly readable
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-892">
                  <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center text-success flex-shrink-0 mt-0.5" data-id="element-893">
                    ✓
                  </div>
                  <p className="text-muted-foreground" data-id="element-894">
                    <span className="font-medium text-foreground" data-id="element-895">
                      Share the TikTok WITH the transcript
                    </span>{' '}
                    — context plus content
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-896">
                  <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center text-success flex-shrink-0 mt-0.5" data-id="element-897">
                    ✓
                  </div>
                  <p className="text-muted-foreground" data-id="element-898">
                    <span className="font-medium text-foreground" data-id="element-899">
                      Lower the friction
                    </span>{' '}
                    — they can read even if they can't watch
                  </p>
                </li>
                <li className="flex items-start gap-3" data-id="element-900">
                  <div className="w-6 h-6 rounded-full bg-success/20 flex items-center justify-center text-success flex-shrink-0 mt-0.5" data-id="element-901">
                    ✓
                  </div>
                  <p className="text-muted-foreground" data-id="element-902">
                    <span className="font-medium text-foreground" data-id="element-903">
                      Strengthen connections
                    </span>{' '}
                    — share what matters, how it matters
                  </p>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
        {/* How It Works */}
        <div className="mb-12 animate-fade-in" style={{
        animationDelay: '400ms'
      }} data-id="element-904">
          <h2 className="text-2xl font-bold mb-6" data-id="element-905">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-906">
            <div className="flex flex-col items-center text-center p-4" data-id="element-907">
              <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-908">
                <MessageSquare size={24} className="text-primary" data-id="element-909" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-910">
                Step 1: Text ScribeTok
              </h3>
              <p className="text-sm text-muted-foreground" data-id="element-911">
                Send any TikTok link to {phoneNumber} and get a transcript back
                in seconds
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-912">
              <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-913">
                <FileText size={24} className="text-primary" data-id="element-914" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-915">
                Step 2: Get Transcript
              </h3>
              <p className="text-sm text-muted-foreground" data-id="element-916">
                Receive a readable version of the TikTok content via SMS with a
                shareable link
              </p>
            </div>
            <div className="flex flex-col items-center text-center p-4" data-id="element-917">
              <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mb-4" data-id="element-918">
                <Share2 size={24} className="text-primary" data-id="element-919" />
              </div>
              <h3 className="text-lg font-medium mb-2" data-id="element-920">Step 3: Share Both</h3>
              <p className="text-sm text-muted-foreground" data-id="element-921">
                Forward the transcript text or share the link with your
                partner—they'll get it either way
              </p>
            </div>
          </div>
        </div>
        {/* SMS Card */}
        <div className="mb-12 animate-fade-in" style={{
        animationDelay: '500ms'
      }} data-id="element-922">
          <Card className="max-w-lg mx-auto" data-id="element-923">
            <CardContent className="p-6 flex flex-col items-center" data-id="element-924">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4" data-id="element-925">
                <Smartphone size={28} className="text-primary" data-id="element-926" />
              </div>
              <h2 className="text-xl font-medium mb-2" data-id="element-927">Text This Number</h2>
              <p className="text-sm text-muted-foreground mb-4" data-id="element-928">
                One text = shareable transcript your partner will actually read
              </p>
              <div className="flex items-center gap-2 px-4 py-2 bg-secondary rounded-full cursor-pointer mb-4 hover:bg-secondary/80 transition-colors" onClick={handleCopyNumber} data-id="element-929">
                <span className="font-medium" data-id="element-930">{phoneNumber}</span>
                {copied ? <Check size={16} className="text-green-500" data-id="element-931" /> : <Copy size={16} data-id="element-932" />}
              </div>
              <a href={smsHref} className="w-full mb-4" data-id="element-933">
                <Button size="lg" className="w-full" data-id="element-934">
                  <MessageSquare size={16} className="mr-2" data-id="element-935" />
                  Text Now
                </Button>
              </a>
              <p className="text-xs text-muted-foreground text-center" data-id="element-936">
                By texting us, you consent to receive automated reply messages.
                Message & data rates may apply.
              </p>
            </CardContent>
          </Card>
        </div>
        {/* Example Conversation */}
        <div className="mb-12 animate-fade-in" style={{
        animationDelay: '600ms'
      }} data-id="element-937">
          <h2 className="text-2xl font-bold mb-6" data-id="element-938">See How It Works</h2>
          <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left max-w-xl mx-auto" data-id="element-939">
            <div className="space-y-4" data-id="element-940">
              <div className="flex justify-end" data-id="element-941">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-942">
                  https://www.tiktok.com/@username/video/1234567890
                </div>
              </div>
              <div className="flex justify-start" data-id="element-943">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-944">
                  <p className="flex items-start gap-2" data-id="element-945">
                    <span className="text-xl flex-shrink-0" data-id="element-946">🎬</span>
                    <span data-id="element-947">
                      Thanks for using ScribeTok! You'll receive a transcript
                      shortly.
                    </span>
                  </p>
                </div>
              </div>
              <div className="flex justify-start" data-id="element-948">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-949">
                  <p className="flex items-start gap-2" data-id="element-950">
                    <span className="text-xl flex-shrink-0" data-id="element-951">✅</span>
                    <span data-id="element-952">Transcript ready!</span>
                  </p>
                  <p className="mt-2 ml-7" data-id="element-953">
                    "This new recipe hack is going to change your life. First,
                    take the avocado and slice it lengthwise..."
                  </p>
                  <div className="mt-3 ml-7 flex items-center" data-id="element-954">
                    <Button size="sm" variant="outline" className="rounded-full text-primary border-primary/30 bg-primary/10" data-id="element-955">
                      <Share2 size={14} className="mr-1.5" data-id="element-956" />
                      Share with transcript
                    </Button>
                  </div>
                  <p className="text-xs mt-3 text-primary font-medium ml-7" data-id="element-957">
                    share.scribetok.com/v/b70c860b-d7dc-4570-ae26-1235c94ee654
                  </p>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-958">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-959">
                  <p className="flex items-start gap-2" data-id="element-960">
                    <span className="text-xl flex-shrink-0" data-id="element-961">👍</span>
                    <span data-id="element-962">Perfect! I'll forward this to Alex.</span>
                  </p>
                </div>
              </div>
              <div className="flex justify-start" data-id="element-963">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-964">
                  <p className="flex items-start gap-2" data-id="element-965">
                    <span className="text-xl flex-shrink-0" data-id="element-966">💯</span>
                    <span data-id="element-967">
                      Tip: Forward this message or share the link - they can
                      read it even when they can't watch!
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Native Share Example */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '650ms'
      }} data-id="element-968">
          <h2 className="text-2xl font-bold mb-6" data-id="element-969">Share Both, Not Just One</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-970">
            <div className="flex flex-col" data-id="element-971">
              <div className="bg-secondary/30 p-4 rounded-lg mb-4" data-id="element-972">
                <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-973">
                  <Share2 size={18} className="text-primary mr-2" data-id="element-974" />
                  The Old Way
                </h3>
                <div className="relative border border-border rounded-lg p-3 bg-background" data-id="element-975">
                  <div className="flex items-center gap-2 mb-3 text-sm" data-id="element-976">
                    <div className="w-8 h-8 rounded-full bg-gray-300 flex-shrink-0" data-id="element-977"></div>
                    <div data-id="element-978">
                      <p className="font-medium" data-id="element-979">You</p>
                      <p className="text-xs text-muted-foreground" data-id="element-980">Just now</p>
                    </div>
                  </div>
                  <div className="rounded-md overflow-hidden border border-border mb-2" data-id="element-981">
                    <div className="h-32 bg-gray-800 flex items-center justify-center" data-id="element-982">
                      <Play size={32} className="text-white/50" data-id="element-983" />
                    </div>
                  </div>
                  <p className="text-xs text-muted-foreground mb-3" data-id="element-984">
                    tiktok.com/@username/video/1234567890
                  </p>
                  <p className="text-sm italic text-red-500 mt-2" data-id="element-985">
                    ✗ Likely to be ignored
                  </p>
                </div>
              </div>
            </div>
            <div className="flex flex-col" data-id="element-986">
              <div className="bg-secondary/30 p-4 rounded-lg mb-4" data-id="element-987">
                <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-988">
                  <Share2 size={18} className="text-primary mr-2" data-id="element-989" />
                  The ScribeTok Way
                </h3>
                <div className="relative border border-border rounded-lg p-3 bg-background" data-id="element-990">
                  <div className="flex items-center gap-2 mb-3 text-sm" data-id="element-991">
                    <div className="w-8 h-8 rounded-full bg-gray-300 flex-shrink-0" data-id="element-992"></div>
                    <div data-id="element-993">
                      <p className="font-medium" data-id="element-994">You</p>
                      <p className="text-xs text-muted-foreground" data-id="element-995">Just now</p>
                    </div>
                  </div>
                  <div className="rounded-md overflow-hidden border border-border mb-2" data-id="element-996">
                    <div className="h-32 bg-gray-800 flex items-center justify-center" data-id="element-997">
                      <Play size={32} className="text-white/50" data-id="element-998" />
                    </div>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2" data-id="element-999">
                    tiktok.com/@username/video/1234567890
                  </p>
                  <div className="p-3 bg-primary/5 rounded-md border border-primary/20 mt-2" data-id="element-1000">
                    <p className="text-sm font-medium text-primary mb-1" data-id="element-1001">
                      📝 Transcript:
                    </p>
                    <p className="text-sm" data-id="element-1002">
                      "This new recipe hack is going to change your life. First,
                      take the avocado and slice it lengthwise..."
                    </p>
                  </div>
                  <p className="text-sm italic text-green-500 mt-2" data-id="element-1003">
                    ✓ They'll get it either way!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Perfect For Section */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '700ms'
      }} data-id="element-1004">
          <h2 className="text-2xl font-bold mb-6" data-id="element-1005">
            Perfect For When Your Partner...
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6" data-id="element-1006">
            <Card className="bg-secondary/30 p-4 text-left" data-id="element-1007">
              <div className="flex items-start gap-3" data-id="element-1008">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1009">
                  <Clock size={20} className="text-primary" data-id="element-1010" />
                </div>
                <div data-id="element-1011">
                  <p className="font-medium" data-id="element-1012">Is too busy</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1013">
                    Can't watch right now but can quickly read a text
                  </p>
                </div>
              </div>
            </Card>
            <Card className="bg-secondary/30 p-4 text-left" data-id="element-1014">
              <div className="flex items-start gap-3" data-id="element-1015">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1016">
                  <FileText size={20} className="text-primary" data-id="element-1017" />
                </div>
                <div data-id="element-1018">
                  <p className="font-medium" data-id="element-1019">Prefers reading</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1020">
                    Some people just absorb information better through text
                  </p>
                </div>
              </div>
            </Card>
            <Card className="bg-secondary/30 p-4 text-left" data-id="element-1021">
              <div className="flex items-start gap-3" data-id="element-1022">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1023">
                  <Smartphone size={20} className="text-primary" data-id="element-1024" />
                </div>
                <div data-id="element-1025">
                  <p className="font-medium" data-id="element-1026">Is in public</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1027">
                    No headphones or not appropriate to play audio
                  </p>
                </div>
              </div>
            </Card>
          </div>
        </div>
        {/* Comparison Table */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '800ms'
      }} data-id="element-1028">
          <h2 className="text-2xl font-bold mb-6" data-id="element-1029">
            The Relationship Difference
          </h2>
          <div className="overflow-hidden rounded-xl border border-border" data-id="element-1030">
            <table className="w-full" data-id="element-1031">
              <thead className="bg-secondary/50" data-id="element-1032">
                <tr data-id="element-1033">
                  <th className="p-4 text-left font-medium" data-id="element-1034">Old Way</th>
                  <th className="p-4 text-left font-medium" data-id="element-1035">ScribeTok Way</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-1036">
                <tr data-id="element-1037">
                  <td className="p-4 text-muted-foreground" data-id="element-1038">
                    Just the TikTok link
                  </td>
                  <td className="p-4 text-primary font-medium" data-id="element-1039">
                    TikTok + readable transcript together
                  </td>
                </tr>
                <tr data-id="element-1040">
                  <td className="p-4 text-muted-foreground" data-id="element-1041">
                    "Did you watch it?" fight
                  </td>
                  <td className="p-4 text-primary font-medium" data-id="element-1042">
                    "Saw what you meant!" moment
                  </td>
                </tr>
                <tr data-id="element-1043">
                  <td className="p-4 text-muted-foreground" data-id="element-1044">
                    Needs sound/headphones
                  </td>
                  <td className="p-4 text-primary font-medium" data-id="element-1045">
                    Read or watch - their choice
                  </td>
                </tr>
                <tr data-id="element-1046">
                  <td className="p-4 text-muted-foreground" data-id="element-1047">
                    Missed connection
                  </td>
                  <td className="p-4 text-primary font-medium" data-id="element-1048">
                    Shared moments, even on busy days
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* Testimonials */}
        <div className="mb-16 animate-fade-in" style={{
        animationDelay: '900ms'
      }} data-id="element-1049">
          <h2 className="text-2xl font-bold mb-6" data-id="element-1050">What Couples Are Saying</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1051">
            <Card className="text-left" data-id="element-1052">
              <CardContent className="p-6" data-id="element-1053">
                <div className="flex items-center gap-3 mb-4" data-id="element-1054">
                  <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center" data-id="element-1055">
                    <Heart size={20} className="text-primary" data-id="element-1056" />
                  </div>
                  <div data-id="element-1057">
                    <p className="font-medium" data-id="element-1058">Sarah & Mike</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1059">
                      Dating 3 years
                    </p>
                  </div>
                </div>
                <p className="text-muted-foreground italic" data-id="element-1060">
                  "Mike never watched the TikToks I sent him. Now I share the
                  video WITH the transcript and he finally understands why I was
                  laughing so hard!"
                </p>
              </CardContent>
            </Card>
            <Card className="text-left" data-id="element-1061">
              <CardContent className="p-6" data-id="element-1062">
                <div className="flex items-center gap-3 mb-4" data-id="element-1063">
                  <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center" data-id="element-1064">
                    <Heart size={20} className="text-primary" data-id="element-1065" />
                  </div>
                  <div data-id="element-1066">
                    <p className="font-medium" data-id="element-1067">Alex & Jordan</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1068">
                      Married 5 years
                    </p>
                  </div>
                </div>
                <p className="text-muted-foreground italic" data-id="element-1069">
                  "I'm always in meetings and can't watch videos. Having the
                  transcript right there with the TikTok lets me stay connected
                  with what my partner finds funny or interesting."
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
        {/* CTA Section */}
        <div className="mb-12 animate-fade-in" style={{
        animationDelay: '1000ms'
      }} data-id="element-1070">
          <Card className="bg-primary/5 border-primary/20" data-id="element-1071">
            <CardContent className="p-8" data-id="element-1072">
              <h2 className="text-2xl font-bold mb-4" data-id="element-1073">
                Stop Being Ignored — Make Your TikToks Unmissable
              </h2>
              <p className="text-lg text-muted-foreground mb-6 max-w-xl mx-auto" data-id="element-1074">
                Your partner doesn't have to choose between watching or
                ignoring. Give them both the video AND the transcript.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1075">
                <a href={smsHref} data-id="element-1076">
                  <Button size="lg" className="w-full sm:w-auto" data-id="element-1077">
                    <MessageSquare size={16} className="mr-2" data-id="element-1078" />
                    Text Now
                  </Button>
                </a>
                <Link to="/features" data-id="element-1079">
                  <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-1080">
                    Explore More Features
                    <ArrowRight size={16} className="ml-2" data-id="element-1081" />
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
        {/* Trust Indicators */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-muted-foreground mb-8 animate-fade-in" style={{
        animationDelay: '1100ms'
      }} data-id="element-1082">
          <div className="flex items-center gap-2" data-id="element-1083">
            <CheckCircle size={16} className="text-success" data-id="element-1084" />
            <span data-id="element-1085">Strengthening Relationships</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-1086">
            <CheckCircle size={16} className="text-success" data-id="element-1087" />
            <span data-id="element-1088">Free To Try</span>
          </div>
        </div>
        {/* Footer */}
        <div className="mt-8 border-t border-border/50 pt-4 text-xs text-muted-foreground" data-id="element-1089">
          <p data-id="element-1090">
            ScribeTok is a user-initiated SMS service. We do not send
            promotional messages. You can opt out at any time by replying STOP.
            Msg & data rates may apply.
          </p>
          <p className="mt-2" data-id="element-1091">
            <Link to="/text/compliance" className="text-primary hover:underline" data-id="element-1092">
              View full terms
            </Link>
          </p>
        </div>
      </div>
    </div>;
}